const fastMergeByProp = (prop, a = [], b = [], rulesFn) => {
  const keyFn = Array.isArray(prop) ? (o) => prop.map((p) => o?.[p]).join('\u0001') : (o) => o?.[prop];

  const aMap = new Map(a.map((x) => [keyFn(x), x]));
  const bMap = new Map(b.map((x) => [keyFn(x), x]));
  const keys = new Set([...aMap.keys(), ...bMap.keys()]);

  const out = [];
  keys.forEach((k) => {
    const va = aMap.get(k);
    const vb = bMap.get(k);
    if (va && vb) out.push(typeof rulesFn === 'function' ? rulesFn(va, vb) : vb);
    else if (va) out.push(va);
    else out.push(vb);
  });
  return out;
};

export default fastMergeByProp;
